import React from 'react';
import { useDroppable } from '@dnd-kit/core';

import Card from './Card';

const Slots = ({
  slot,
  pickup,
  date,
  schedulePickup,
  assignDriverToPickup,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `slot-${slot}`,

    data: {
      slot,
      date,
    },
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        display: 'flex',
        gap: 16,
        minHeight: 60,
        borderBottom: '1px solid #ececec',
        padding: '12px 0',
        background: isOver ? '#eef6ff' : '#fff',
        transition: '.2s',
      }}
    >
      {/* Slot */}

      <div
        style={{
          width: 90,
          flexShrink: 0,
          fontWeight: 700,
          color: '#6c757d',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        Slot {slot}
      </div>

      {/* Content */}

      <div
        style={{
          flex: 1,
        }}
      >
        {pickup ? (
          <Card pickup={pickup} />
        ) : (
          <div
            style={{
              border: '2px dashed #d7d7d7',
              borderRadius: 10,
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#999',
              fontSize: 14,
            }}
          >
            Drop delivery here
          </div>
        )}
      </div>
    </div>
  );
};

export default Slots;
